// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"styles_searchBar__KCIDO","loopIcon":"styles_loopIcon__375Ma","searchInput":"styles_searchInput__-4Pig"};